module.exports = __webpack_public_path__ + "img/huawei_placeholder.88da5462.jpg";